import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {TasksByUserIdListWrapper} from './components/TasksByUserList'

const TasksByUserPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        {/* `/tasksbyuser` sem usuário não tem tela própria: vai para todas as tarefas (antes ficava em branco) */}
        <Route index element={<Navigate to='/tarefas' replace />} />
        <Route path=':userId' element={<TasksByUserIdListWrapper />} />
      </Route>
    </Routes>
  )
}

export default TasksByUserPage
